<template>
    <div class="appleDevelopmentClass">
      <div>
        <HeaderView />
      </div>
      <div>
        <WebDevelopmentA />
      </div>
      <div>
        <FooterView />
      </div>
    </div>
    </template>
    
    <script>
    import HeaderView from "@/components/HeaderView.vue";
    import FooterView from "@/components/FooterView.vue";
    import WebDevelopmentA from "@/components/ServicePages/WebDevelopmentPage/WebDevelopmentA.vue";
    
    
    export default {
      name: "ColorRain",
      components: {
        HeaderView,
        WebDevelopmentA,
        FooterView,
      },
    };
    </script>
    
    <style scoped>
    
    </style>
      